import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from 'src/routes/ProtectedRoute';
import PageNotFound from 'src/shared/components/page-not-found/PageNotFound';
import { getSiteNatureRiskRoutesAvailability } from 'src/routes/state/routesSelector';
import { useAppSelector } from 'src/store';
import { IndividualRouteSetting, SiteNatureRiskViews } from 'src/routes/routesConfig';
import { Resources } from 'src/shared/types';
import SiteNatureRiskOverview from './views/overview/SiteNatureRiskOverview';
import SiteNatureRiskCharacteristics from './views/characteristics/SiteNatureRiskCharacteristics';
import SiteNatureRiskStateOfNature from './views/state-of-nature/SiteNatureRiskStateOfNature';
import SiteNatureRiskImpactsAndDependencies from './views/impacts-and-dependencies/SiteNatureRiskImpactsAndDependencies';

export const siteNatureRiskRouteSettings: { [key in SiteNatureRiskViews]: IndividualRouteSetting } = {
    overview: {
        name: 'Site Nature Risk Overview',
        path: '/:siteId/overview',
        handler: <SiteNatureRiskOverview />,
        resource: Resources.SITE_NATURE_RISK,
    },
    characteristics: {
        name: 'Site Nature Risk Characteristics',
        path: '/:siteId/characteristics',
        handler: <SiteNatureRiskCharacteristics />,
        resource: Resources.SITE_NATURE_RISK,
    },
    stateOfNature: {
        name: 'Site Nature Risk State of Nature',
        path: '/:siteId/state-of-nature',
        handler: <SiteNatureRiskStateOfNature />,
        resource: Resources.SITE_NATURE_RISK,
    },
    impactsAndDependencies: {
        name: 'Site Nature Risk Impacts and Dependencies',
        path: '/:siteId/impacts-and-dependencies',
        handler: <SiteNatureRiskImpactsAndDependencies />,
        resource: Resources.SITE_NATURE_RISK,
    },
};

const SiteNatureRisk = () => {
    const routesConfig = useAppSelector(getSiteNatureRiskRoutesAvailability);

    if (!routesConfig) {
        return null;
    }

    return (
        <Routes>
            {Object.keys(routesConfig).map(routeKey => {
                const isAvailable = routesConfig[routeKey as SiteNatureRiskViews];
                const routeSetting = siteNatureRiskRouteSettings[routeKey as SiteNatureRiskViews];

                if (!routeSetting) {
                    return null;
                }

                return (
                    <Route
                        path={routeSetting.path}
                        element={
                            <ProtectedRoute isAllowed={isAvailable} redirectPath={'/customers'} routeSetting={routeSetting}>
                                {routeSetting.handler}
                            </ProtectedRoute>
                        }
                        key={routeSetting.name}
                    />
                );
            })}
            <Route path='/*' element={<PageNotFound />} />
        </Routes>
    );
};

export default SiteNatureRisk;
